var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChordsPalette = function SvgChordsPalette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chords-palette_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chords-palette_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chords-palette_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.863 3.5c-8.283 0-15 6.716-15 15 0 8.283 6.717 15 15 15 1.384 0 2.5-1.117 2.5-2.5 0-.65-.241-1.234-.65-1.675a2.476 2.476 0 0 1-.625-1.659c0-1.383 1.117-2.5 2.5-2.5h2.942c4.6 0 8.333-3.733 8.333-8.333 0-7.367-6.716-13.333-15-13.333Zm-9.166 15a2.497 2.497 0 0 1-2.5-2.5c0-1.384 1.116-2.5 2.5-2.5 1.383 0 2.5 1.116 2.5 2.5 0 1.383-1.117 2.5-2.5 2.5Zm5-6.667a2.497 2.497 0 0 1-2.5-2.5c0-1.383 1.116-2.5 2.5-2.5 1.383 0 2.5 1.117 2.5 2.5s-1.117 2.5-2.5 2.5Zm8.333 0a2.497 2.497 0 0 1-2.5-2.5c0-1.383 1.117-2.5 2.5-2.5s2.5 1.117 2.5 2.5-1.117 2.5-2.5 2.5Zm5 6.667a2.497 2.497 0 0 1-2.5-2.5c0-1.384 1.117-2.5 2.5-2.5s2.5 1.116 2.5 2.5c0 1.383-1.117 2.5-2.5 2.5Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.608 3.949c.761.191 1.514-.348 1.681-1.205.168-.856-.314-1.706-1.076-1.898-.761-.191-1.515.348-1.682 1.205-.167.857.315 1.706 1.077 1.898ZM20.807 35.28c.483.122.96-.22 1.066-.764.106-.543-.2-1.081-.682-1.203-.483-.121-.96.22-1.067.764-.106.543.2 1.082.683 1.203Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.847 23.716c4.008 1.739 4.707 1.556 7.509-1.793-1.714 4.055-1.533 4.762 1.78 7.6-4.009-1.738-4.708-1.556-7.51 1.794 1.721-4.026 1.551-4.75-1.78-7.6ZM1.285 14.836c2.68-1.459 2.885-1.924 2.298-4.927 1.44 2.709 1.9 2.916 4.869 2.32-2.68 1.459-2.885 1.924-2.298 4.927-1.42-2.7-1.885-2.921-4.869-2.32Z",
    fill: "#fff",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chords-palette_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h60v35H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chords-palette_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.863 2.5)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chords-palette_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.863 3.5)",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgChordsPalette;